/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import InputBox from '../../../../components/InputBox'
import ErrorMessage from '../../../../components/ErrorMessage'
import TextArea from '../../../../components/TextArea'
import Dropdown from '../../../../components/Dropdown'
import TopHeader from '../../../../components/TopHeader'
import { useState ,useContext,useEffect} from 'react'
import { useNavigate ,useParams,useLocation} from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import GlobalContext from '../../../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { useCallback } from 'react'
import { useLazyViewOrganizationUserQuery } from '../../../../features/organizationUserSlice'
import Debounce from '../../../../CommonMethods/Debounce'
import { validateEmail } from '../../../../CommonMethods/EmailValidator'
import CustomOverLay from '../../../../components/CustomOverLay'
import { motion } from 'framer-motion'
import { handleEditMessageSent,handleTargetUserEditId } from '../../../../redux/systemConfigSlice'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import Loader from '../../../../components/Loader'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen'
import {useEditOrgUserMutation, useLazyGetOrgUserSubdivisionsQuery, useViewOrganizationUserQuery,useDeleteOrgUserAssociatedOrganizationMutation,useLinkOrgUsertoOrganizationMutation,useLazyViewWebsocketOrganizationUserQuery } from '../../../../features/organizationUserSlice'
import PhoneNumberValidator from '../../../../components/PhoneNumberInput'
import SubDivTable from './SubdivTable'
import { phoneCodeArray } from '../../../../CommonMethods/phoneNumberCountryCodes'
import { useUpdateEmailMutation } from '../../../../features/apiSlice'
import { userService } from '../../../../services/user.services'
import HelpGuideModal from '../../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import { resetProviderSearch } from '../../../../redux/providerSearchSlice'

export default function EditOrganizationUser({edit}) {
    const location=useLocation()
    const [addOrganizationUserDetails,setAddOrganizationUserDetails]=useState({
        "user_name":"",
        "first_name":"",
        "last_name":"",
        "mobile_number":"",
        "main_number":"",
        "sub_division":"",
        "email_addr":"",
        "permission_access":true,
    })
    
    const {id}=useParams()

    const isFromEdit = location?.state?.[1] || false; 
    const userArr=useSelector(state=>state?.userSelect?.selectedUsers?.checkedArr)
    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const organization_id=useSelector(state=>state?.systemConfigData?.organization_id)
    const [skip,setSkip]=useState(true)
    const [linkOrgUser]=useLinkOrgUsertoOrganizationMutation()
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const { data, isFetching, status } = useViewOrganizationUserQuery(`${id}?action=view`)
    const [websocketTrigger,webSocketRes] = useLazyViewWebsocketOrganizationUserQuery()
    const [confirmationState,setConfirmationState]=useState(false)
    const [confirmationStateCancel,setConfirmationStateCancel]=useState(false)
    const [statusToggle,setStatusToggle]=useState(false)
    const [confirmationChangeStatus,setConfirmationChangeStatus]=useState(false)
    const { setToastmessage,setToastErrorMessage ,isSideBar,editSocket,setEditSocket,sendMessageToStopEditing,sendMessageToStartEditing,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const [emptyField, setEmptyField] = useState(false)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [dataloading,setDataLoading] = useState(true)
    const [emailError,setEmailError]=useState({
        "email_error":false,
        "text":false,
        "username_error":false
    })  
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true});
    const [suggestions,setSuggestions] = useState('')
    const [loading,setLoading]=useState(false)
    const navigate=useNavigate()
    const [userId,setUserId] = useState('')
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')
    const [emptyArea,setEmptyArea]=useState(false);
    const [usernameError,setUsernameError]=useState(false)
    const [loadingStatus,setLoadingStatus]=useState(false)
    const [isSubDelete, setIsSubDelete]=useState(false)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const [editOrganizationUser]=useEditOrgUserMutation()
    const [submitSelected,setSubmitSelected]=useState(false);
    const [selectedRowtoDelete, setSelectedRowtoDelete] = useState({});
    const [deleteModel, setDeleteModel] = useState(false);
    const dispatch=useDispatch()
    const [deleteLoading,setdeleteLoading] = useState(false)
    const [linkOrganizationModel, setLinkOrganizationModel] = useState(false);
    const [trigger,result,lastPromiseinfo] = useLazyViewOrganizationUserQuery()
    const [subTrigger,subresult] =useLazyGetOrgUserSubdivisionsQuery()
    const [isOpensub,setisOpensub] = useState(false)
    const [deleteAssociatedOrganization] = useDeleteOrgUserAssociatedOrganizationMutation()
    const [payload,setpayload] = useState({})
    const [selectedSubdivisionName,setSelectedSubdivisionName] = useState([])
    const [searchParams, setSearchParams] = useState(`${id}?page_number=1&limit=15&action=list`);
    const [totalPageNumber, setTotalPageNumber] = useState(1);
    const [limit, setLimit] = useState(15);

    const [updateEmail] = useUpdateEmailMutation()
    const [emailButtonLoading,setEmailButtonLoading]=useState(false)
    const [emailVefiedButton,setEmailVeriedButton]=useState(true);
    const [nextTarget, setNextTarget] = useState('');


    
    function handleOnChangeUserDetails(id,option){
        setSubmitSelected(false)
        setEmptyField(false)
        setEmailError({
            email_error:false,
            username_error:false,
            "text":false
        })
        const fieldToUpdate = {
            user_name:"user_name",
            first_name:"first_name",
            last_name:"last_name",
            mobile_number:"mobile_number",
            main_number:"main_number", 
            sub_division:"sub_division",
            email_addr:'email_addr',
            admin_toggle:"admin_toggle",
            user_toggle:"user_toggle",    
            permission_access:"permission_access",      
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true

        if (id === "mobile_number"||id==="main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setAddOrganizationUserDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if(fieldToUpdate){
            setIsDisableCancel(false)
            if(fieldToUpdate==="permission_access"){
                setAddOrganizationUserDetails((prev) => ({
                    ...prev,
                    "permission_access": !addOrganizationUserDetails.permission_access,
                }));
            }
            else if(fieldToUpdate==="mobile_number"||fieldToUpdate==="main_number"){
                if(option.length<=20){
                    setAddOrganizationUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="first_name"||fieldToUpdate==="last_name"){
                if(option.length<=30){
                    setAddOrganizationUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if(fieldToUpdate==="email_addr"||fieldToUpdate==="user_name"){
                setUsernameError(false)
                setEmailVeriedButton(true)
                setEmailButtonLoading(false)
                if(option.length<=80){
                    setAddOrganizationUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.trim(),
                    }));

                }
            }
            else{
                setAddOrganizationUserDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
            
        }

    }

    const handleChange=(val,user_id)=>{
        if(val.trim()!==''){
            subTrigger(`filter=true&organization_id=${organization_id}&search=${encodeURIComponent(val)}&user_id=${user_id}`)

        }else{
            subTrigger(`filter=true&organization_id=${organization_id}&user_id=${user_id}`)
        }   
    }

    

    const fetchPageAndLimit=()=>{
        const splitQuery = searchParams.split('?')[1];
        const params = new URLSearchParams(splitQuery); 
        return params
    }


   

    const handleSubdivisionSearchTrigger=useCallback(
        Debounce((value,userId)=>handleChange(value,userId)),
        []
    )

    const handleSubdivisionListSearch = (value,isApiCall) => {
        setSuggestions(value)
        handleSubdivisionSearchTrigger(value,userId)    
    }



    const handleSelectionSubdivision = (item) => {
    
        setSelectedSubdivisionName((prevState) => {
            const subdivisions = Array.isArray(prevState) ? prevState : []; // Ensure prevState is always an array
            const isSelected = subdivisions.some(subdiv => subdiv?.subdivision_id === item?.subdivision_id);
            
            if (isSelected) {
                // Remove the item if already selected
                return subdivisions.filter(subdiv => subdiv?.subdivision_id !== item?.subdivision_id);
            } else {
                // Add the item if not selected
                return [...subdivisions, item];
            }
        });
    
        setpayload(item);
        // Uncomment if needed:
        // setisOpensub(false);
    };
    
    
    const handleCloseLinkModel = () => {
        setLinkOrganizationModel(false)
    }
    const handleAddSubdivision = async()=>{
        setisOpensub(false);
        setdeleteLoading(true)
    
        let body={
            "subdivision_id":selectedSubdivisionName?.map(item=>item?.subdivision_id)
        }
        setisOpensub(false)
        const response = await linkOrgUser({userId,body})
        if(response?.data?.message === "Sub Division linked successfully") {
            setToastmessage(response?.data?.message)
            setSelectedSubdivisionName('')
            setLinkOrganizationModel(false)
            trigger(searchParams)
            setdeleteLoading(false)
        } else {
            setToastErrorMessage(response?.error?.data?.message);
            setisOpensub(false);
            setSelectedSubdivisionName('')
            setLinkOrganizationModel(false)
            setdeleteLoading(false)
          
        }     
    }

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };




    useEffect(() => {
        trigger(searchParams)
        
    }, [searchParams])

    useEffect(() => {
        if (edit) {
            setQueryParamsadmin('type=admin-edit-org-user');
        } else {
            setQueryParamsadmin('type=admin-add-org-user');
        }
    }, [edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    


    useEffect(()=>{
        const calculatedTotalPages = calculateTotalPages(result?.data?.total_count, fetchPageAndLimit().get("limit"));
        setTotalPageNumber(calculatedTotalPages);
    },[result])


    useEffect(()=>{
        if(id){
            websocketTrigger(`${id}?action=view`)      
        }  
                
    },[id])

    
    const handleDeleteAssociatedOrganization = (item, index) => {
        setisOpensub(false)
        if(result?.data?.data?.length===1){
            setToastErrorMessage('Atleast one sub division is required')
            return
        }
        setSelectedRowtoDelete(item)
        setDeleteModel(true)
        setIsSubDelete(true)
    }

    const handleConfirmDelete = async () => {
        
        setdeleteLoading(true)
        let body={
            "subdivision_id":selectedRowtoDelete.sub_division_id
        }
        let subdivision_id=selectedRowtoDelete.sub_division_id
        const response = await deleteAssociatedOrganization({userId,subdivision_id})
    
        if (response?.error ) {
            setToastErrorMessage(editRes?.error?.data?.message)
            setDeleteModel(false)
            setdeleteLoading(false)
        } else{
            setToastmessage('Sub Division removed successfully')
            setDeleteModel(false)
            trigger(searchParams)
            setdeleteLoading(false)
        }
    }

    const handleCloseDeleteModal = () => {
        setDeleteModel(false)
    }


    const handleOnAddOrganizationUser=async()=>{
        setSubmitSelected(true)
        const hasEmptyFields = () => {
            let isFieldsEmpty=false
            if (
                addOrganizationUserDetails.user_name.trim() === "" ||
                addOrganizationUserDetails.first_name.trim() === "" ||
                addOrganizationUserDetails.last_name.trim() === "" ||
                addOrganizationUserDetails.main_number.trim() === ""||
                addOrganizationUserDetails.email_addr.trim() === ""||
                userArr[0].length===0
                // addOrganizationUserDetails.sub_division.trim() === ""
            ) {
                isFieldsEmpty = true;
            }
            return isFieldsEmpty;

        };
        if (hasEmptyFields()) {

            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");

            return;

        }
        if(validateEmail(addOrganizationUserDetails?.user_name?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "username_error":true,
                "text":true
            }))
           
            if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":true

                }))
               
            }
            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
        }
        if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  

            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true

            }))
            setLoading(false);
            return
        }
        if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true

            }))
            return
        }
        if ((!(isPhoneNumberValid.main_number)&&addOrganizationUserDetails?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&addOrganizationUserDetails?.mobile_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        else{
            setConfirmationState(true)
        }

    }
   
    const handleFinalSubmit=async()=>{
        try {
            setLoading(true)
            let response = null
         
            let body = {
                "user_name":addOrganizationUserDetails?.user_name.trim().replace(/\s/g, ''),
                "first_name": addOrganizationUserDetails?.first_name.trim(),
                "last_name": addOrganizationUserDetails?.last_name.trim(),
                // "email_address": addOrganizationUserDetails?.email_addr.trim().replace(/\s/g, ''),
                "mobile_number": addOrganizationUserDetails?.mobile_number,
                "main_number": addOrganizationUserDetails?.main_number,
                "mobile_country_code": "+"+(countryCodeVal!==""?countryCodeVal?.split('\t').join('')?.trim():country_code?.split('\t').join('')?.trim()),
                "main_country_code": "+"+(countryCodeVal2!==""?countryCodeVal2?.split('\t').join('')?.trim():country_code?.split('\t').join('')?.trim()),
                "permission_access": addOrganizationUserDetails?.permission_access === true ? "admin" : "user",                
            }
        
        
            
            const addRes=await editOrganizationUser({id,body})
            if(addRes?.error?.data?.message==="Email Address must be a valid email address"){
                setConfirmationState(false)
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":true
                }))
                setLoading(false);                  
                    
            }
            else if(addRes?.error?.data?.message){
                setToastErrorMessage(addRes?.error?.data?.message)
                setLoading(false)
                if(addRes?.error?.data?.message==="Username already exists. Please try another"){
                    setUsernameError(true)
                }
            }
            else{
                navigate(`/manage-organizations/manage-organization-users/${id}`,{state:location.state})
                setToastmessage('Organization user updated successfully');
                setLoading(false)
            }
               
            
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }
    }

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    localStorage.setItem('showLogoutToast', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(() => {
        const userId = webSocketRes?.data?.data?.[0]?.user_id;
        //if the user_id is not there from response return 
        if (!userId) return;
        
        if (webSocketRes !== undefined) {

            dispatch(handleTargetUserEditId(webSocketRes?.data?.data?.[0]?.user_id))
            if(edit&&!messageSent&&editSocket){
               
                sendMessageToStartEditing(webSocketRes?.data?.data?.[0]?.user_id)
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-organizations/manage-organization-users')
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this organization user`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            
            subTrigger(`filter=true&organization_id=${organization_id}&user_id=${webSocketRes?.data?.data[0]?.user_id}`)
            setUserId(webSocketRes?.data?.data[0]?.user_id)
            setSkip(true)
            setAddOrganizationUserDetails((prev) => ({
                ...prev,
                "user_name": webSocketRes?.data?.data[0]?.user_name,
                "first_name": webSocketRes?.data?.data[0]?.first_name,
                "last_name": webSocketRes?.data?.data[0]?.last_name,
                "mobile_number": webSocketRes?.data?.data[0]?.mobile_number,
                "main_number":webSocketRes?.data?.data[0]?.main_number,
                "email_addr": webSocketRes?.data?.data[0]?.email_address,
                "permission_access": webSocketRes?.data?.data[0]?.permission_access === 'admin' ? true : false,
            }));
    
            setStatusToggle(webSocketRes?.data?.data[0]?.status === "inactive" ? false : true);
            setSkip(false)
        }
    
        if (webSocketRes?.data) {
            setCountryCodeVal(webSocketRes?.data?.data[0]?.main_country_code?.split('+')[1]);
            setCountryCodeVal2(webSocketRes?.data?.data[0]?.mobile_country_code?.split('+')[1]);
        }
    }, [webSocketRes]);
    
 
    useEffect(()=>{
        return(()=>{
            if(location?.state!==null||location?.state!==''){
                sendMessageToStopEditing()
            }
        })
       
    },[])
    const handleConformationClick = () => {
        
        setEmptyArea(false)
        setTextAreaMsg("")
        
        setConfirmationState(false);
        setConfirmationChangeStatus(false)
    }
    const handleConformationClickCancel = () => {
        
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    const handleCancel = () => {
        setConfirmationStateCancel(false);
        // Clear form values
        setAddOrganizationUserDetails({
            "user_name": "",
            "first_name": "",
            "last_name": "",
            "mobile_number": "",
            "main_number": "",
            "sub_division": "",
            "email_addr": "",
            "permission_access": true,
        });
        if (nextTarget === 'view') {
            navigate(`/manage-organizations/manage-organization-users/${id}`);
        } else {
            navigate('/manage-organizations/manage-organization-users');
        }
        // navigate('/manage-organizations/manage-organization-users')
    };
    
    const handleCancelBottom = () => {
        const stateToPass = Array.isArray(location.state) ? '' : location.state;

        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-organizations/manage-organization-users/${id}`,{state:location.state})
        } else if (isDisableCancel) {
            navigate('/manage-organizations/manage-organization-users/',{state:stateToPass});
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }    
        // const values = Object.values(addOrganizationUserDetails);
        // const isAnyValueFilled = values?.some((value) => typeof value!== "boolean" &&value?.trim() !== ""); // Check if any value is filled
        // if(isDisableCancel){
        //     navigate('/manage-organizations/manage-organization-users/')
        // }
        // if (isAnyValueFilled) {
        //     setConfirmationStateCancel(true);
        // } else {
        //     setConfirmationStateCancel(false);
        //     // navigate('/manage-organizations/manage-organization-users/add-organization-user');
        // }
    };

    const handleOnCLickActivate = async(e) => {
        // useDispatch(handleIsAPICall(true))
        if(statusToggle===false&& textAreaMsg.trim()===""){ 
            setToastErrorMessage('Please fill in the mandatory field')
        
            setEmptyArea(true)
            
            return;
        }
        try {
            let body = { }
            if(statusToggle===false){
                body={
                    "user_names": [addOrganizationUserDetails.user_name],
                    "status":"inactive",
                    "note" : textAreaMsg 
                } 
            }
            else{
                body={
                    "user_names": [addOrganizationUserDetails.user_name],
                    "status":"active",
                    "note":''
                } 
            }
            
            setLoadingStatus(true)
            const activationRes=await editOrganizationUser({body})

            
            setLoadingStatus(false)
            
            if(activationRes.error){
                setToastErrorMessage(activationRes?.error?.data?.message)
            }else{
                setToastmessage(`Organization user ${statusToggle===true?"activated":"deactived"} successfully`);
                
            }
            setConfirmationChangeStatus(false)
            setTextAreaMsg('');
           
        } catch (error) {
            setConfirmationChangeStatus(false)
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }
    const handleOnVerifyEmail=async()=>{
            
           
        if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true
            }))

            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
               
        }
        try {
            setEmailButtonLoading(true)
            let response = null
            let body={}
            body={
                "user_type":"organization-user",
                "email_address": addOrganizationUserDetails.email_addr.trim().replace(/\s/g, ''),
            }
            const emailVerifyRes=await updateEmail({id,body})

            if(emailVerifyRes?.error?.data?.message==="Email Address must be a valid email address"){
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":true
                })) 
                setEmailButtonLoading(false)
            }
            else if(emailVerifyRes?.error?.data?.message){
                setConfirmationState(false)
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":false
                })) 
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailButtonLoading(false)
            }
            else{
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)   
                setEmailVeriedButton(false)
            }
            setIsDisableCancel(true)
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }

    }

    
    const handleGoBackToOrgList = (e) => {
        e.preventDefault();
        dispatch(resetProviderSearch());
        setIsAdvancedSearchOpen(false);
        navigate("/manage-organizations", { state: Array.isArray(location.state) ? '' : location.state });
    };

    return (
        <>
            
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full'>
                <TopHeader title={"Manage Organization User"}/>
                {((edit&&webSocketRes?.isFetching&&webSocketRes?.status!=="fulfilled"))?<CustomOverLay Active text="Edit Organization User..." classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>
                    <div className='bg-white rounded-lg pb-[12px] pt-3.5 pl-6 pr-[10px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='pr-6'>
                                    <div className='flex items-center mb-5'>
                                        
                                        <h1 className="text-sm font-normal text-[#52555D] cursor-pointer"
                                            onClick={handleGoBackToOrgList}
                                        >List of Organizations</h1>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <Link to={`/manage-organizations/${viewId}`}>
                                            <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <Link to="/manage-organizations/manage-organization-users" state={Array.isArray(location.state)?'':location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Organization Users</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <Link to={`/manage-organizations/manage-organization-users/${location.state?.[2]}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Organization User</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`Edit Organization User`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    {isFromEdit===true ?
                                        <div onClick={handleCancelBottom} className=' items-center cursor-pointer min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Organization User</span>
                                        </div> :
                                        <div onClick={handleCancelBottom} state={Array.isArray(location.state)?'':location.state} className='flex items-center cursor-pointer'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3 cursor-pointer'>Go back to Listing</span>
                                        </div>
                                    }
                                    
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        {`Edit Organization User`}
                                    </h1>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className={`pr-5 h-customh16 overflow-auto overflow-x-hidden scrollbar_purple bg-white`}>
                                    <div className="border border-[#C5C9DA] rounded-sm px-6 2xl:px-[57px] py-4 mb-4">
                                        
                                        <div className='flex flex-wrap -mx-3'>
                                            <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Username*"} 
                                                        placeholder={"Enter username"}
                                                        id={"user_name"}
                                                        htmlFor={"Admin_Username"}
                                                        value={addOrganizationUserDetails.user_name}
                                                        emailError={emailError.username_error}
                                                        usernameError={usernameError}
                                                        disabled={true}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.user_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                    {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"First Name*"} 
                                                        placeholder={"Enter first name"}
                                                        datatestid={"first_name"}
                                                        id={"first_name"}
                                                        htmlFor={"Admin_First_Name"}
                                                        value={addOrganizationUserDetails.first_name}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.first_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Last Name*"} 
                                                        placeholder={"Enter last name"}
                                                        id={"last_name"}
                                                        datatestid={"last_name"}
                                                        htmlFor={"Admin_Last_Name"}
                                                        value={addOrganizationUserDetails.last_name}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.last_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    
                                                    <PhoneNumberValidator
                                                        label={"Mobile Number"}
                                                        placeholder={"Enter Mobile Number"}
                                                        id={"mobile_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addOrganizationUserDetails.mobile_number}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal2}
                                                        isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        setCountryCodeVal={setCountryCodeVal2}
                                                        submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                    />    
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                  
                                                    <PhoneNumberValidator
                                                        label={"Main Number*"} 
                                                        placeholder={"Enter Main Number"}
                                                        id={"main_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addOrganizationUserDetails.main_number}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.main_number?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal}
                                                        setCountryCodeVal={setCountryCodeVal}
                                                        isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}

                                                    />
                                                </div>
                                            </div>
                                            <div className={`w-1/3 px-3 mb-[22px]`}></div>
                                            <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Email Address*"} 
                                                        placeholder={"Enter email address"}
                                                        id={"email_addr"}
                                                        htmlFor={"email_addr"}
                                                        value={addOrganizationUserDetails.email_addr}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.email_addr?.trim()===""}
                                                        emailError={emailError.email_error}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                    {emailError.email_error && <ErrorMessage error  message={emailError?.text&&"Invalid email address"}/>}
                                                </div>
                                            </div>
                                            {( (webSocketRes?.data?.data[0]?.email_address !== addOrganizationUserDetails?.email_addr)) && 
                                            <div className={`w-2/3 px-[18px] mb-[35px] pt-3.5`}>
                                                <button type='button'
                                                    id="verify"
                                                    onClick={() => handleOnVerifyEmail()}
                                                    disabled={emailButtonLoading || !emailVefiedButton || addOrganizationUserDetails?.email_addr?.trim()===""}
                                                    className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                    {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                                </button>
                                            </div>
                                            }
                                                
                                            {((webSocketRes?.data?.data[0]?.email_address === addOrganizationUserDetails?.email_addr)) && 
                                            <div className={`w-2/3 px-[18px] mb-[35px] pt-3`}>
                                                <button type='button'
                                                    id="verified"
                                                    className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                        bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                    <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                        <img src="/images/success_toast.svg" alt="icon" loading='lazy'  className='w-3.5 h-3.5' decoding='async' />
                                                    </span>
                                                    Verified
                                                </button>
                                            </div>
                                            }

                                            <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <p className='text-sm font-semibold text-[#000000] mb-1.5'>Permission Access</p>
                                                    <div className='flex items-center'>
                                                        <div className="p-2">
                                                            <div className="relative custom-radioBlue flex items-center">
                                                                <input id="admin_true" type="radio" name="default-radio1" checked={addOrganizationUserDetails?.permission_access} onChange={()=>handleOnChangeUserDetails("permission_access",false)}/>
                                                                <label htmlFor="admin_true" className={`text-base font-normal ${addOrganizationUserDetails?.permission_access ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                                    Admin
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="p-2">
                                                            <div className="relative custom-radioBlue flex items-center" >
                                                                <input id="user_true"  type="radio" name="default-radio1" checked={!addOrganizationUserDetails?.permission_access} onChange={()=>handleOnChangeUserDetails("permission_access",true)}/>
                                                                <label htmlFor="user_true" className={`text-base font-normal ${!addOrganizationUserDetails?.permission_access ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                                    User 
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-[18px] mb-[22px] self-center'>
                                                <div className='w-full'>
                                                    <div className="status custom-toggle flex items-center ">
                                                        <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                                            Status
                                                        </p> 
                                                        <label className="switch" style={{marginLeft: '10px'}}>
                                                            <input type="checkbox" id="user_status" onChange={(e)=>{
                                                                setIsDisableCancel(false),
                                                                setStatusToggle(!statusToggle),setConfirmationChangeStatus(true)
                                                            }} checked={statusToggle} /><span className="slider round"></span>
                                                        </label>
                                                        <p className="text-sm font-normal  text-[#008586] disable_switch ml-3">
                                                            {statusToggle?'Active':'Inactive'}
                                                        </p> 
                                                    </div>
                                                </div>
                                            </div>
                                            <SubDivTable 
                                                user_id={webSocketRes?.data?.data[0]?.user_id}
                                                result={result}
                                                isOpensub={isOpensub}
                                                subdivisionData={subresult?.data}
                                                value={suggestions}
                                                handleSubdivisionListSearch={handleSubdivisionListSearch}
                                                handleAddAssociation={handleAddSubdivision}
                                                selectedSubdivisionName={selectedSubdivisionName}
                                                setSelectedSubdivisionName={setSelectedSubdivisionName}
                                                setisOpensub={setisOpensub}
                                                handleSelectionSubdivision={handleSelectionSubdivision}
                                                subdivisionloadingstatus={subresult}
                                                limit={limit}
                                                setLimit={setLimit}
                                                totalPageNumber={totalPageNumber}
                                                fetchPageAndLimit={fetchPageAndLimit}
                                                searchParams={searchParams}
                                                setSearchParams={setSearchParams}
                                                handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                                setLinkOrganizationModel={setLinkOrganizationModel}
                                                isSubDelete={isSubDelete} 
                                                setIsSubDelete={setIsSubDelete}
                                            />
                                        </div>
                                    </div>
                                    
                                </div> 
                                <div className='flex justify-end pr-5'>
                                    <button
                                        type="button"
                                        id="cancel"
                                        onClick={() => handleCancelBottom()}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#972E4C] disabled:opacity-50 rounded-[16px] mt-2.5 w-[148px]
                                        border border-[#972E4C]`}
                                    >
                                        Cancel
                                    </button>

                                    <button type='button'
                                        id="update"
                                        onClick={handleOnAddOrganizationUser}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px] ml-4
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                        Update
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {confirmationState && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={""}
                                handleOnCLickActivate={handleFinalSubmit}
                                handleClose={handleConformationClick}
                                tittle= {"Update Organization User"}
                                message = {`Are you sure you want to update this organization user?`}
                                textMessage = {true===false?false:true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    /> 
                }
                {confirmationStateCancel && 
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                textMessage = {true===false?false:true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                CancelButton={'No'}
                            />
                        }
                    /> 
                }
                {confirmationChangeStatus && 
                <AnimatedModel 
                    Children={
                        <ConfirmationPrompt
                            emptyField={emptyArea}
                            setEmptyField={setEmptyArea}
                            disabled={loadingStatus}
                            setTextAreaMsg={setTextAreaMsg}
                            textAreaMsg={textAreaMsg}
                            loadingActivation={loadingStatus}
                            handleOnCLickActivate={handleOnCLickActivate}
                            handleClose={()=>{setStatusToggle(!statusToggle),handleConformationClick()}}
                            tittle= {statusToggle?'Activate':'Deactivate'}
                            message = {`Are you sure you want to ${statusToggle? 'activate' : 'deactivate'} the following organization user?`}
                            textMessage = {statusToggle===false?false:true}
                            buttonName = {statusToggle?'Activate':'Deactivate'}
                        />
                    }
                /> 
                }
                {linkOrganizationModel &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleAddSubdivision}
                            handleClose={handleCloseLinkModel}
                            tittle={'Link Sub Division'}
                            message={`Are you sure you want to link the sub division?`}
                            buttonName={"Yes"}
                            loadingActivation={deleteLoading}
                            CancelButton={"No"}
                            disabled={deleteLoading}
                        />
                    }
                />

                }
                {deleteModel &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleConfirmDelete}
                            handleClose={handleCloseDeleteModal}
                            tittle={'Remove'}
                            message={`Are you sure you want to remove the subdivision?`}
                            buttonName={"Confirm"}
                            loadingActivation={deleteLoading}
                            // CancelButton={"No"}
                            disabled={deleteLoading}
                        />
                    }
                />}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }
            </div>
        </>
    )}
